import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private loginTriggerSource = new Subject<void>();

  loginTrigger$ = this.loginTriggerSource.asObservable();

  triggerLogin() {
    this.loginTriggerSource.next();
  }
}
